import {
  AllSidesIcon,
  CardStackMinusIcon,
  CodeSandboxLogoIcon,
  DragHandleDots1Icon,
  DragHandleDots2Icon,
  FileTextIcon,
  GroupIcon,
  LapTimerIcon,
  MixIcon,
  PaddingIcon,
  PersonIcon,
  TransparencyGridIcon
} from '@radix-ui/react-icons';
import { ElementType } from "react";
import { routes } from "../routes";
import { claims } from "../utils/claims";
type MenuItemType = {
  icon?: ElementType;
  title: string;
  key: string;
  permissions: string[];
  subItems?: SubMenuItemType[];
};
type SubMenuItemType = {
  icon?: ElementType;
  title: string;
  route: string;
  permission: string;
  subItems?: MenuItemType[];
};
export const menuItems: MenuItemType[] = [
  {
    icon: PersonIcon,
    title: 'Gestão de utilizadores',
    key: 'users',
    permissions: [claims.CanGetUsersWithPagination, claims.CanCreateUser, claims.CanUpdatePasswordPolicy],
    subItems: [
      { title: 'Listagem de utilizadores', route: routes.users, permission: claims.CanGetUsersWithPagination },
      { title: 'Criar utilizador', route: routes.createUser, permission: claims.CanCreateUser },
      { title: 'Políticas da senha', route: routes.changePasswordPolicy, permission: claims.CanUpdatePasswordPolicy },
    ],
  },
  {
    icon: GroupIcon,
    title: 'Gestão de perfis',
    key: 'roles',
    permissions: [claims.CanGetRoles, claims.CanCreateRole, claims.CanAddClaimsToRole],
    subItems: [
      { title: 'Listagem de perfis', route: routes.roles, permission: claims.CanGetRoles },
      { title: 'Criar perfil', route: routes.createRole, permission: claims.CanCreateRole },
      { title: 'Associar permissões a perfis', route: routes.addClaimsToRole, permission: claims.CanAddClaimsToRole },
    ],
  },
  {
    icon: PersonIcon,
    title: 'Gestão de Ctas',
    key: 'ctas',
    permissions: [claims.CanGetCtas, claims.CanCreateCta],
    subItems: [
      { title: 'Listagem de ctas', route: routes.ctas, permission: claims.CanGetCtas },
      { title: 'Criar cta', route: routes.createCta, permission: claims.CanCreateCta },
    ],
  },
  {
    icon: CardStackMinusIcon,
    title: 'Gestão instituiçöes de ensino superior',
    key: 'universities',
    permissions: [claims.CanGetUniversities, claims.CanCreateUniversity],
    subItems: [
      { title: 'Listagem de instituiçöes de ensino superior', route: routes.universities, permission: claims.CanGetUniversities },
      { title: 'Criar instituição de ensino superior', route: routes.createUniversity, permission: claims.CanCreateUniversity },
    ],
  },
  {
    icon: CardStackMinusIcon,
    title: 'Gestão de Unidades orgânicas',
    key: 'faculties',
    permissions: [claims.CanGetFaculties, claims.CanCreateFaculty],
    subItems: [
      { title: 'Listagem de unidades orgânica', route: routes.faculties, permission: claims.CanGetFaculties },
      { title: 'Criar unidade orgânica', route: routes.createFaculty, permission: claims.CanCreateFaculty },
    ],
  },
  {
    icon: FileTextIcon,
    title: 'Gestão de Departamentos',
    key: 'departaments',
    permissions: [claims.CanGetDepartments, claims.CanCreateDepartment],
    subItems: [
      { title: 'Listagem de Departamentos', route: routes.departaments, permission: claims.CanGetDepartments },
      { title: 'Criar Departamento', route: routes.createDepartament, permission: claims.CanCreateDepartment },
    ],
  },
  {
    icon: MixIcon,
    title: 'Gestão de Cursos',
    key: 'courses',
    permissions: [claims.CanGetCourses, claims.CanCreateCourse],
    subItems: [
      { title: 'Listagem de cursos', route: routes.courses, permission: claims.CanGetCourses },
      { title: 'Criar (curso / programa)', route: routes.createCourse, permission: claims.CanCreateCourse },
    ],
  },
  {
    icon: CodeSandboxLogoIcon,
    title: 'Ano lectivo',
    key: 'academicYears',
    permissions: [claims.CanGetAcademicYears],
    subItems: [
      { title: 'Ano lectivo', route: routes.academicYears, permission: claims.CanGetAcademicYears },
      { title: 'Criar ano lectivo', route: routes.createAcademicYear, permission: claims.CanCreateAcademicYear }
    ],
  },
  {
    title: 'Vagas',
    key: 'vacancies',
    permissions: [claims.CanGetVacancies, claims.CanCreateVacancy],
    subItems: [
      { title: 'Listagem de vagas', route: routes.vacancies, permission: claims.CanGetVacancies },
      { title: 'Criar vaga', route: routes.createVacancy, permission: claims.CanCreateVacancy },
    ],
  },
  {
    icon: AllSidesIcon,
    title: 'Gestão de Áreas Científicas',
    key: 'scientificAreas',
    permissions: [claims.CanGetScientificAreas, claims.CanCreateScientificArea],
    subItems: [
      { title: 'Listagem de áreas científicas', route: routes.scientificAreas, permission: claims.CanGetScientificAreas },
      { title: 'Criar área científica', route: routes.createScientificAreas, permission: claims.CanCreateScientificArea },
    ],
  },
  {
    icon: DragHandleDots1Icon,
    title: 'Gestão de Disciplinas',
    key: 'subjects',
    permissions: [claims.CanGetSubjects, claims.CanCreateSubject],
    subItems: [
      { title: 'Listagem de disciplinas', route: routes.subjects, permission: claims.CanGetSubjects },
      { title: 'Criar disciplina', route: routes.createSubject, permission: claims.CanCreateSubject },
    ],
  },
  {
    icon: DragHandleDots2Icon,
    title: 'Gestão de Planos de Cursos',
    key: 'coursePlans',
    permissions: [claims.CanGetCoursePlan, claims.CanCreateCoursePlan],
    subItems: [
      { title: 'Listagem de plano de cursos', route: routes.coursePlans, permission: claims.CanGetCoursePlan },
      { title: 'Criar plano de curso', route: routes.createCoursePlan, permission: claims.CanCreateCoursePlan },
    ],
  },
  {
    icon: DragHandleDots2Icon,
    title: 'Gestão de Disciplinas de Planos de Cursos',
    key: 'coursesSubjects',
    permissions: [claims.CanGetPlanSubject, claims.CanCreatePlanSubject],
    subItems: [
      { title: 'Listagem de disciplinas de Planos de Cursos', route: routes.planSubjects, permission: claims.CanGetPlanSubject },
      { title: '[Criar/Editar] disciplinas de Plano de Curso', route: routes.createUpdatePlanSubjects, permission: claims.CanCreatePlanSubject },
    ],
  },
  // {
  //   icon: DragHandleDots2Icon,
  //   title: 'Gestão de Disciplinas de Cursos',
  //   key: 'coursesSubjects',
  //   permissions: [claims.CanGetCoursesSubjects],
  //   subItems: [
  //     { title: 'Listagem de disciplinas de cursos', route: routes.coursesSubjects, permission: claims.CanGetCoursesSubjects },
  //     { title: 'Criar disciplinas de curso', route: routes.courseSubjectV2, permission: claims.CanGetCoursesSubjects },
  //   ],
  // },
  {
    icon: LapTimerIcon,
    title: 'Gestão de Período Acadêmico',
    key: 'academicPeriods',
    permissions: [claims.CanGetAcademicPeriods, claims.CanCreateAcademicPeriod],
    subItems: [
      { title: 'Listagem de períodos acadêmicos', route: routes.academicPeriods, permission: claims.CanGetAcademicPeriods },
      { title: 'Criar período acadêmico', route: routes.createAcademicPeriod, permission: claims.CanCreateAcademicPeriod },
    ],
  },
  {
    icon: FileTextIcon,
    title: 'Gestão de documentos para matrícula',
    key: 'enrollmentRequiredDocument',
    permissions: [claims.CanGetEnrollmentRequiredDocuments, claims.CanCreateEnrollmentRequiredDocument],
    subItems: [
      { title: 'Listagem de documentos de matrícula', route: routes.enrollmentrequireddocuments, permission: claims.CanGetEnrollmentRequiredDocuments },
      { title: 'Criar documento para matrícula', route: routes.createEnrollmentRequiredDocument, permission: claims.CanCreateEnrollmentRequiredDocument },
    ],
  },
  {
    icon: TransparencyGridIcon,
    title: 'Gestão de matrículas',
    key: 'enrollments',
    permissions: [claims.CanGetEnrollments, claims.CanCreateEnrollment, claims.CanCreateEnrollment, claims.CanCreateStudentSituation, claims.CanGetStudentsSubscribedSubjects, claims.CanGetStudentStatisticsEnrollments],
    subItems: [
      { title: 'Listagem de matrículas', route: routes.enrollments, permission: claims.CanGetEnrollments },
      { title: 'Criar matrícula', route: routes.createEnrollment, permission: claims.CanCreateEnrollment },
      { title: 'Renovar matrícula ', route: routes.renewEnrollment, permission: claims.CanCreateEnrollment },
      { title: 'Registo/Consulta irregularidades de estudantes ', route: routes.createStudentSituation, permission: claims.CanCreateStudentSituation },
      { title: 'Estudantes ', route: routes.students, permission: claims.CanGetStudentsSubscribedSubjects },
      { title: 'Estatísticas ', route: routes.studentStatistics, permission: claims.CanGetStudentStatisticsEnrollments },
      { title: 'Códigos duplicados ', route: routes.duplicatedSchoolCodes, permission: claims['CanGetStudents'] },
      { title: 'Estudantes não sincronizados á central ', route: routes.syncStudentsEsuraCentral, permission: claims['CanGetStudents'] },
      { title: 'Carregamento em massa de estudantes ', route: routes.bulkEnrollmentByExcelFile, permission: claims['CanCreateEnrollment'] },
    ],
  },
  { key:'certificates',
    icon: PaddingIcon,
    title: 'Gestão de certificados',
    permissions: [claims.CanGetEnrollments],
    subItems: [
      { title: 'Listagem de certificados', route: routes.certificates, permission: claims.CanGetEnrollments },
      { title: 'Carregar certificado', route: routes.uploadStudentCertificate, permission: claims.CanGetEnrollments },
    ],
  }
  ,
  {
    icon: PaddingIcon,
    title: 'Gestão de inscrições',
    key: 'subscriptions',
    permissions: [claims.CanGetSubscriptions, claims.CanGetSubscriptionStatisticsByCourse, claims.CanGetSubscriptionStatistics, claims.CanCreateSubscription, claims.CanCreateMySubscription, claims.CanGetSubscriptionsByIDStudent],
    subItems: [
      { title: 'Inscrições', route: routes.subscriptions, permission: claims.CanGetSubscriptions },
      { title: 'Validação das Inscrições', route: routes.subscriptionsValidation, permission: claims.CanGetSubscriptions },
      { title: 'Inscrições por curso', route: routes.subscriptionsStatisticsCourse, permission: claims.CanGetSubscriptionStatisticsByCourse },
      { title: 'Inscrições por disciplina', route: routes.subscriptionsStatistics, permission: claims.CanGetSubscriptionStatistics },
      { title: 'Inscrever estudante', route: routes.createSubscription, permission: claims.CanCreateSubscription },
      { title: 'Matriculas', route: routes.renewMyEnrollment, permission: claims.CanGetSubscriptionsByIDStudent },
      { title: 'Pré-inscrição', route: routes.createMySubscription, permission: claims.CanCreateMySubscription },
      { title: 'Minhas-Inscrições', route: routes.studentSubscription, permission: claims.CanGetSubscriptionsByIDStudent },
    ],
  },
  {
    icon: PaddingIcon,
    title: 'Gestão de tipo de bolsas',
    key: 'scholarshipstypes',
    permissions: [claims.CanGetScholarshipTypes, claims.CanCreateScholarshipType],
    subItems: [
      { title: 'Listagem de tipos de bolsa', route: routes.scholarshipTypes, permission: claims.CanGetScholarshipTypes },
      { title: 'Criar tipo de bolsa', route: routes.createScholarshipType, permission: claims.CanCreateScholarshipType },
    ],
  },
  {
    icon: PaddingIcon,
    title: 'Gestão de provedores de bolsas',
    key: 'scholarshipsproviders',
    permissions: [claims.CanGetScholarshipProviders, claims.CanCreateScholarshipProvider],
    subItems: [
      { title: 'Listagem de provedores de bolsa', route: routes.scholarshipProviders, permission: claims.CanGetScholarshipProviders },
      { title: 'Criar provedor de bolsa', route: routes.createScholarshipProvider, permission: claims.CanCreateScholarshipProvider },
    ],
  },
  {
    icon: PaddingIcon,
    title: 'Gestão de bolsas',
    key: 'scholarships',
    permissions: [claims.CanGetScholarships, claims.CanCreateScholarship],
    subItems: [
      { title: 'Listagem de bolsas', route: routes.scholarships, permission: claims.CanGetScholarships },
      { title: 'Atribuir bolsa', route: routes.createScholarship, permission: claims.CanCreateScholarship },
    ],
  },
  {
    icon: FileTextIcon,
    title: 'Gestão de documentos para docente',
    key: 'teacherRequiredDocument',
    permissions: [claims.CanGetRulesTeacherDocuments, claims.CanCreateRulesTeacherDocument],
    subItems: [
      { title: 'Listagem de documentos para docente', route: routes.teacherRequiredDocuments, permission: claims.CanGetRulesTeacherDocuments },
      { title: 'Criar documento para docente', route: routes.createTeacherRequiredDocument, permission: claims.CanCreateRulesTeacherDocument },
    ],
  },
  {
    title: 'Gestão de docentes',
    key: 'teachers',
    permissions: [claims.CanGetTeachers, claims.CanCreateTeacher, claims.CanGetTeacherEvaluationCriterias, claims.CanCreateTeacherEvaluationCriteria],
    subItems: [
      { title: 'Listagem de docentes', route: routes.teachers, permission: claims.CanGetTeachers },
      { title: 'Criar docente', route: routes.createTeacher, permission: claims.CanCreateTeacher },
      { title: 'Critérios de avaliação ', route: routes.teacherEvaluationCriterias, permission: claims.CanGetTeacherEvaluationCriterias },
      { title: 'Criar Critério de avaliação ', route: routes.createTeacherEvaluationCriteria, permission: claims.CanCreateTeacherEvaluationCriteria },
    ],
  },
  {
    title: 'Gestão de Tipo de sala',
    key: 'classroomType',
    permissions: [claims.CanGetClassroomTypes, claims.CanCreateClassroomType],
    subItems: [
      { title: 'Listagem de tipos de sala', route: routes.classroomTypes, permission: claims.CanGetClassroomTypes },
      { title: 'Criar tipo de sala', route: routes.createClassroomType, permission: claims.CanCreateClassroomType },
    ],
  },
  {
    title: 'Gestão de salas',
    key: 'classrooms',
    permissions: [claims.CanGetClassrooms, claims.CanCreateClassroom],
    subItems: [
      { title: 'Listagem de salas', route: routes.classrooms, permission: claims.CanGetClassrooms },
      { title: 'Criar sala', route: routes.createClassroom, permission: claims.CanCreateClassroom },
    ],
  },
  {
    title: 'Gestão de turmas',
    key: 'classes',
    permissions: [claims.CanGetClasses, claims.CanCreateClass, claims.CanGetAssessments, claims.CanBlockOrUnblockStudentAssessment],
    subItems: [
      { title: 'Listagem de turmas', route: routes.classes, permission: claims.CanGetClasses },
      { title: 'Criar turma', route: routes.createClass, permission: claims.CanCreateClass },
      { title: 'Ver notas - (Pauta)', route: routes.generalStudentGrades, permission: claims.CanGetAssessments },
      { title: 'Paura geral - Frequência', route: routes.viewStudentGrades, permission: claims.CanGetAssessments },
      { title: 'Paura geral - Exame', route: routes.viewStudentExamGrades, permission: claims.CanGetAssessments },
      { title: 'Bloquear/Desbloquear o lançamento de notas dos estudantes', route: routes.blockOrUnblockStudentGradePosting, permission: claims.CanBlockOrUnblockStudentAssessment },
      { title: 'Notas gerais do estudante', route: routes.studentGeneralGrades, permission: claims.CanCreateStudentSubjectGrade },
    ],
  },
  {
    title: 'Pedidos de Documentos',
    key: 'emitStudentDocuments',
    permissions: [claims.CanGetStudentDocuments, claims.CanCreateStudentDocument],
    subItems: [
      { title: 'Pedidos de Documentos', route: routes.emitStudentDocuments, permission: claims.CanGetStudentDocuments },
      { title: 'Fazer Pedido de documento', route: routes.createStudentDocument, permission: claims.CanCreateStudentDocument },
    ],
  },
  {
    title: 'Avaliações',
    key: 'assessments',
    permissions: [claims.CanGetAssessments_Teacher, claims.CanCreateAssessment, claims.CanCreateGeneralAssessment, claims.CanCreateStudentSubjectGrade, claims.CanGetStudentClasses, claims.CanGetStudentAssessments, claims.CanGetMyStudentAssessments, claims.CanCreateTeacherEvaluation],
    subItems: [
      { title: 'Configurações de avaliações do docente', route: routes.assessments, permission: claims.CanGetAssessments_Teacher },
      { title: '[Criar/Editar] configuração de avaliação', route: routes.createAssessments, permission: claims.CanCreateAssessment },
      { title: '[Criar/Editar] configuração de avaliação geral', route: routes.createGeneralAssessments, permission: claims.CanCreateGeneralAssessment },
      { title: 'Lançar notas', route: routes.addStudentGradesV2, permission: claims.CanCreateStudentSubjectGrade },
      { title: 'Pauta de frequência', route: routes.addStudentGrades, permission: claims.CanCreateStudentSubjectGrade },
      { title: 'Pauta de exames', route: routes.addStudentExamGrades, permission: claims.CanCreateStudentSubjectGrade },
      { title: 'Minhas turmas', route: routes.teacherClasses, permission: claims.CanGetStudentClasses },
      { title: 'Ver notas do estudante', route: routes.findStudentGrades, permission: claims.CanGetStudentAssessments },
      { title: 'Notas', route: routes.studentGrades, permission: claims.CanGetMyStudentAssessments },
      { title: 'Avaliar docentes', route: routes.studentTeacherEvaluation, permission: claims.CanCreateTeacherEvaluation },
    ],
  },
  {
    title: 'Horário',
    key: 'schedules',
    permissions: [claims.CanGetSchoolSchedules],
    subItems: [
      { title: 'Horário', route: routes.teacherSchedule, permission: claims.CanGetSchoolSchedules },
    ],
  },
  {
    title: 'Planos de aula',
    key: 'lessonPlans',
    permissions: [claims.CanGetSubjectPlans],
    subItems: [
      { title: 'Plano de aula', route: routes.getSubjectPlans, permission: claims.CanGetSubjectPlans },
    ],
  },
  {
    title: 'Calendário',
    key: 'studentSchedule',
    permissions: [claims.CanGetMySchoolSchedules, claims.CanGetMyAssessments],
    subItems: [
      { title: 'Horário', route: routes.studentSchedule, permission: claims.CanGetMySchoolSchedules },
      { title: 'Avaliações', route: routes.myAssessments, permission: claims.CanGetMyAssessments },
    ],
  },
  {
    title: 'Aulas',
    key: 'studentLessonPlans',
    permissions: [claims['CanGetLessonPlans']],
    subItems: [
      { title: 'Aulas', route: routes.getClassLessonPlans, permission: claims.CanGetLessonPlans },
    ],
  },
  {
    title: 'Documentos',
    key: 'studentDocuments',
    permissions: [claims.CanGetStudentDocuments_Student, claims.CanCreateStudentDocument_Student],
    subItems: [
      { title: 'Documentos', route: routes.studentDocuments, permission: claims.CanGetStudentDocuments_Student },
      { title: 'Fazer Pedido de documento', route: routes.requestStudentDocument, permission: claims.CanCreateStudentDocument_Student },
    ],
  },
  {
    title: 'Finanças',
    key: 'studentFinances',
    permissions: [claims.CanGetStudentDebties_Student, claims.CanUpdateStudentDebtNotification],
    subItems: [
      { title: 'Situação financeira', route: routes.getStudentFinanceState, permission: claims.CanGetStudentDebties_Student },
      { title: 'Notificações', route: routes.getStudentFinanceNotifications, permission: claims.CanUpdateStudentDebtNotification },
    ],
  },
  {
    title: 'Responsáveis',
    key: 'managers',
    permissions: [claims.CanGetManagers],
    subItems: [
      { title: 'Listagem de responsáveis', route: routes.getManagers, permission: claims.CanGetManagers },
    ],
  },
  {
    title: 'Entidade financeira',
    key: 'bankEntity',
    permissions: [claims.CanCreateSchoolBankConfig, claims.CanGetSchoolBankConfigs],
    subItems: [
      { title: 'Criar entidade financeira', route: routes.createSchoolBankConfig, permission: claims.CanCreateSchoolBankConfig },
      { title: 'Entidade financeira', route: routes.getSchoolBankConfig, permission: claims.CanGetSchoolBankConfigs },
    ],
  },
  {
    title: 'Tipos de emolumentos',
    key: 'paymentTypes',
    permissions: [claims.CanGetPaymentTypies, claims.CanCreatePaymentType],
    subItems: [
      { title: 'Listagem de tipos de emolumentos', route: routes.paymentTypes, permission: claims.CanGetPaymentTypies },
      { title: 'Criar tipos de emolumentos', route: routes.createPaymentType, permission: claims.CanCreatePaymentType },
    ],
  },
  {
    title: "Taxas por curso",
    key: "coursePayments",
    permissions: [claims.CanGetCoursePayments, claims.CanCreateCoursePayment],
    subItems: [
      {
        title: "Listagem de taxas por curso",
        route: routes.coursePayments,
        permission: claims.CanGetCoursePayments,
      },
      {
        title: "Criar taxa por curso",
        route: routes.createCoursePayment,
        permission: claims.CanCreateCoursePayment,
      },
    ],
  },
  {
    title: "Modelos de processos",
    key: "processModels",
    permissions: [claims.CanGetProcessModels, claims.CanCreateProcessModel],
    subItems: [
      {
        title: "Listagem de modelos de processos",
        route: routes.processModels,
        permission: claims.CanGetProcessModels,
      },
      {
        title: "Criar modelo de processo",
        route: routes.createProcessModel,
        permission: claims.CanCreateProcessModel,
      },
    ],
  },
  // {
  //   title: 'Métodos de pagamento',
  //   key: 'paymentMethods',
  //   permissions: [claims.CanGetPaymentMethods, claims.CanCreatePaymentMethod],
  //   subItems: [
  //     { title: 'Listagem de métodos de pagamento', route: routes.paymentMethods, permission: claims.CanGetPaymentMethods },
  //     { title: 'Criar método de pagamento', route: routes.createPaymentMethod, permission: claims.CanCreatePaymentMethod },
  //   ],
  // },
  {
    title: 'Regras de multas',
    key: 'lateFeeConfig',
    permissions: [claims.CanGetLateFeeConfigies, claims.CanCreateLateFeeConfig],
    subItems: [
      { title: 'Listagem de regras de multas', route: routes.lateFeeConfigs, permission: claims.CanGetLateFeeConfigies },
      { title: 'Criar regra de multas', route: routes.createlateFeeConfig, permission: claims.CanCreateLateFeeConfig },
    ],
  },
  {
    title: 'Cobranças',
    key: 'studentDebts',
    permissions: [claims.CanGetStudentDebties, claims.CanCreateStudentDebt, claims.CanUpdatePaymentReference, claims.CanGetPaymentsReport, claims.CanGetPaymentReferenceStatus, claims.CanUploadPaymentFile],
    subItems: [
      { title: 'Cobranças ', route: routes.studentDebts, permission: claims.CanGetStudentDebties },
      { title: 'Cobranças - (Irregulares)', route: routes.irregularStudentDebts, permission: claims.CanGetStudentDebties },
      { title: 'Criar cobrança', route: routes.createStudentDebt, permission: claims.CanCreateStudentDebt },
      { title: 'Situação financeira do estudante', route: routes.checkStudentDebtByStudent, permission: claims.CanUpdatePaymentReference },
      { title: 'Relatórios de pagamentos ', route: routes.getPaymentReport, permission: claims.CanGetPaymentsReport },
      { title: 'Controle mensal', route: routes.monthPayments, permission: claims.CanGetStudentDebties },
      { title: 'Relatórios de referência ', route: routes.getPaymentReferenceStatus, permission: claims.CanGetPaymentReferenceStatus },
      { title: 'Relatórios de referência avançado ', route: routes.getPaymentReferenceReportAdvanced, permission: claims.CanGetPaymentReferenceStatus },
      { title: 'Carregar ficheiro de pagamento', route: routes.uploadPaymentFile, permission: claims.CanUploadPaymentFile },
    ],
  },
  {
    title: 'Biblioteca',
    key: 'library',
    permissions: [claims.CanGetCategories, claims.CanGetAuthors, claims.CanGetBooks, claims.CanGetLoans, claims.CanGetReservations, claims.CanGetLibraryStats],
    subItems: [
      { title: 'Categorias', route: routes.categories, permission: claims.CanGetCategories },
      { title: 'Autores', route: routes.authors, permission: claims.CanGetAuthors },
      { title: 'Livros ', route: routes.books, permission: claims.CanGetBooks },
      { title: 'Empréstimos', route: routes.loans, permission: claims.CanGetLoans },
      { title: 'Reservas', route: routes.reservations, permission: claims.CanGetReservations },
      { title: 'Relatórios', route: routes.libraryStats, permission: claims.CanGetLibraryStats },
    ],
  },
  {
    title: 'Gestão de projectos',
    key: 'projects',
    permissions: [claims.CanGetEntities, claims.CanGetSubEntities, claims.CanGetProjectTypes, claims.CanGetPhases, claims.CanGetProjects, claims.CanGetProjectsAssignedByIdJudge],
    subItems: [
      { title: 'Entidades', route: routes.entities, permission: claims.CanGetEntities },
      { title: 'SubEntidades', route: routes.subEntities, permission: claims.CanGetSubEntities },
      { title: 'Tipos de projectos', route: routes.projectTypes, permission: claims.CanGetProjectTypes },
      { title: 'Fases ', route: routes.phases, permission: claims.CanGetPhases },
      { title: 'Comissão de validação', route: routes.judges, permission: claims.CanGetJudges },
      { title: 'Projectos', route: routes.projects, permission: claims.CanGetProjects },
      { title: 'Validação de fases', route: routes.projectsAssignedToJudge, permission: claims.CanGetProjectsAssignedByIdJudge },
    ],
  },
   {
  title: 'Configurações',
  key: 'settings',
  permissions: [claims.CanCreateSettings, claims.CanGetSettings],
  subItems: [
    { title: 'Configurações do Sistema', route: routes.settings, permission: claims.CanGetSettings },
  ],
},
];
